
import { Institution } from "@/api/dtos";
import useInstitutions from "@/hooks/data/useInstitutions";
import { createContext } from "react"

export interface IInstitutionsContext extends ReturnType<typeof useInstitutions> {
}

export const InstitutionsContext = createContext<IInstitutionsContext>({
    data: undefined,
    idMap: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default InstitutionsContext;